module.exports = __webpack_public_path__ + "static/media/sia-health-wellness.55f2529d.png";